import * as Interface from './types';
export enum Api {
	/**
	 * 获取用户的孩子列表
	 */
	GetChildrenListByUserUid = 'GetChildrenListByUserUid',
	/**
	 * 获取用户设备列表
	 */
	GetDevicesByUserUid = 'GetDevicesByUserUid',
	/**
	 * 查询学生家长个数
	 */
	GetParentStudentList = 'GetParentStudentList',
	/**
	 * 根据用户token查询用户信息
	 */
	GetUserInfo = 'GetUserInfo',
	/**
	 * 根据用户uid查询用户信息
	 */
	GetUserDetailInfo = 'GetUserDetailInfo',
	/**
	 * 查询云班学校信息以及管理员信息
	 */
	GetYunbanUnitInfo = 'GetYunbanUnitInfo',
	/**
	 * 删除常驻区域 http://swqa.gz.cvte.cn/#/interfaceTest/project/SeewoSafetyService/interfaceView/api/12313/interface/65764
	 */
	DeleteMobileRegionStayV1 = 'DeleteMobileRegionStayV1',
	/**
	 * 获取所有常驻区域 http://swqa.gz.cvte.cn/#/interfaceTest/project/SeewoSafetyService/interfaceView/api/12313/interface/65761
	 */
	GetMobileRegionStayV1 = 'GetMobileRegionStayV1',
	/**
	 * 添加常驻区域 http://swqa.gz.cvte.cn/#/interfaceTest/project/SeewoSafetyService/interfaceView/api/12313/interface/65762
	 */
	PostMobileRegionStayV1 = 'PostMobileRegionStayV1',
	/**
	 * 更新常驻区域 http://swqa.gz.cvte.cn/#/interfaceTest/project/SeewoSafetyService/interfaceView/api/12313/interface/65763
	 */
	PutMobileRegionStayV1 = 'PutMobileRegionStayV1',
	/**
	 * 批量删除指定消息
	 */
	DeleteNotification = 'DeleteNotification',
	/**
	 * 获取消息分组列表
	 */
	GetNotificationGroup = 'GetNotificationGroup',
	/**
	 * 获取指定消息分组的统计信息
	 */
	GetNotificationGroupStatistics = 'GetNotificationGroupStatistics',
	/**
	 * 将指定分组的消息都置为已读
	 */
	PostSetNotificatioNGroupHasRead = 'PostSetNotificatioNGroupHasRead',
	/**
	 * 
	 */
	RequestActionByContentCallback = 'RequestActionByContentCallback',
	/**
	 * 获取二级消息列表
	 */
	GetNotificationList = 'GetNotificationList',
	/**
	 * 获取未读消息总数
	 */
	GetNotificationNotReadMessageNums = 'GetNotificationNotReadMessageNums',
	/**
	 * 获取提醒类型消息
	 */
	GetNotificationRecordRemindItems = 'GetNotificationRecordRemindItems',
	/**
	 * 二级消息跳转时的权限校验
	 */
	PostCheckPermission = 'PostCheckPermission',
	/**
	 * 标记消息是否已读
	 */
	PostNotificationMarkRead = 'PostNotificationMarkRead',
	/**
	 * 点击消息 PopupMenu 时所携带的 ContentCallback 请求
	 */
	PostRequestAction = 'PostRequestAction',
	/**
	 * 注销用户
	 */
	PostLoginAccountCancel = 'PostLoginAccountCancel',
	/**
	 * 检测是否满足注销条件
	 */
	PostLoginAccountCancelCheck = 'PostLoginAccountCancelCheck',
	/**
	 * 检测是否满足注销条件(小程序)
	 */
	PostLoginAccountMiniCancelCheck = 'PostLoginAccountMiniCancelCheck',
	/**
	 * 【登录】H5关联绑定用户
	 */
	PostLoginInfo = 'PostLoginInfo',
	/**
	 * 删除所有代收短信
	 */
	DeleteDeviceAllMessages = 'DeleteDeviceAllMessages',
	/**
	 * 删除代收短信
	 */
	DeleteDeviceMessage = 'DeleteDeviceMessage',
	/**
	 * 删除守护区域
	 */
	DeleteGuardArea = 'DeleteGuardArea',
	/**
	 * 获取用户管理的设备列表
	 */
	GetAdminDevices = 'GetAdminDevices',
	/**
	 * 根据设备编号获取学生证信息
	 */
	GetCardInfoBySncode = 'GetCardInfoBySncode',
	/**
	 * 获取学校上课免打扰
	 */
	GetClassDisableSchoolConfig = 'GetClassDisableSchoolConfig',
	/**
	 * 获取自定义上课免打扰
	 */
	GetClassDisableSelfConfig = 'GetClassDisableSelfConfig',
	/**
	 * 根据设备编号获取绑定信息
	 */
	GetDeviceBindInfo = 'GetDeviceBindInfo',
	/**
	 * 根据设备编号获取绑定信息
	 */
	GetDeviceDetailInfo = 'GetDeviceDetailInfo',
	/**
	 * 定位模式设置查询
	 */
	GetDeviceLocationPattern = 'GetDeviceLocationPattern',
	/**
	 * 根据设备编号获取绑定信息
	 */
	GetDevicePhoneForUser = 'GetDevicePhoneForUser',
	/**
	 * 开关机管理设置查询
	 */
	GetDevicePowerPlanConfig = 'GetDevicePowerPlanConfig',
	/**
	 * 代收短信设置查询
	 */
	GetDeviceReceiveMessageConfig = 'GetDeviceReceiveMessageConfig',
	/**
	 * 代收短信分页查询
	 */
	GetDeviceReceiveMessages = 'GetDeviceReceiveMessages',
	/**
	 * 获取设备各种开关配置
	 */
	GetDeviceSwitchInfo = 'GetDeviceSwitchInfo',
	/**
	 * 获取安全守护区域列表
	 */
	GetGuardAreaList = 'GetGuardAreaList',
	/**
	 * 获取守护记录信息
	 */
	GetGuardRecord = 'GetGuardRecord',
	/**
	 * 获取安全守护配置开关状态
	 */
	GetGuardSettingSwitchInfo = 'GetGuardSettingSwitchInfo',
	/**
	 * 获取申请记录
	 */
	GetApplicantInfo = 'GetApplicantInfo',
	/**
	 * 获取我的设备列表
	 */
	GetMyDevices = 'GetMyDevices',
	/**
	 * 获取实时定位信息
	 */
	GetPositionV1Realtime = 'GetPositionV1Realtime',
	/**
	 * 获取设备的轨迹信息
	 */
	GetTrajectoryV1 = 'GetTrajectoryV1',
	/**
	 * 获取设备的步数信息
	 */
	GetTrajectoryV1Step = 'GetTrajectoryV1Step',
	/**
	 * 添加守护区域
	 */
	AddGuardArea = 'AddGuardArea',
	/**
	 * 修改自定义上课免打扰
	 */
	PostClassDisableSelfConfig = 'PostClassDisableSelfConfig',
	/**
	 * 发送绑定申请
	 */
	PostDeviceBindApplication = 'PostDeviceBindApplication',
	/**
	 * 设备绑定孩子
	 */
	PostDeviceBindChild = 'PostDeviceBindChild',
	/**
	 * 守护通知反馈
	 */
	PostDeviceLocationFeedback = 'PostDeviceLocationFeedback',
	/**
	 * 定位模式设置
	 */
	PostDeviceLocationPattern = 'PostDeviceLocationPattern',
	/**
	 * 设置设备的手机号
	 */
	PostDevicePhoneNumber = 'PostDevicePhoneNumber',
	/**
	 * 开关机管理设置
	 */
	PostDevicePowerPlanConfig = 'PostDevicePowerPlanConfig',
	/**
	 * 代收短信设置
	 */
	PostDeviceReceiveMessageConfig = 'PostDeviceReceiveMessageConfig',
	/**
	 * 定位模式设置
	 */
	PostDeviceSwitchStatus = 'PostDeviceSwitchStatus',
	/**
	 * 解绑设备
	 */
	PostDeviceUnbind = 'PostDeviceUnbind',
	/**
	 * 下发获取设备定位指令
	 */
	PostPositionV1Realtime = 'PostPositionV1Realtime',
	/**
	 * 更改守护开关
	 */
	PutGuardSwitchStatus = 'PutGuardSwitchStatus',
	/**
	 * 修改守护区域
	 */
	UpdateGuardArea = 'UpdateGuardArea',
	/**
	 * 通话联系人查询
	 */
	GetContactConfig = 'GetContactConfig',
	/**
	 * 通话联系人设置
	 */
	PostContactConfig = 'PostContactConfig',
	/**
	 * 亲情号查询
	 */
	GetFamilyConfig = 'GetFamilyConfig',
	/**
	 * 亲情号设置
	 */
	PostFamilyConfig = 'PostFamilyConfig',
	/**
	 * SOS号码查询
	 */
	GetSosConfig = 'GetSosConfig',
	/**
	 * SOS号码设置
	 */
	PostSosConfig = 'PostSosConfig',
	/**
	 * 校验验证码是否合法
	 */
	PostSendPhoneValid = 'PostSendPhoneValid',
	/**
	 * 按模板发送短信指定用户
	 */
	PostSendPhoneSms = 'PostSendPhoneSms',
	/**
	 * 取消授权
	 */
	DeleteStudentCardUserAuth = 'DeleteStudentCardUserAuth',
	/**
	 * 查看用户对学校的授权状态
	 */
	GetStudentCardUserAuth = 'GetStudentCardUserAuth',
	/**
	 * 获取用户的角色权限列表
	 */
	GetUserAuth = 'GetUserAuth',
	/**
	 * 同意授权/同意变更授权
	 */
	PostStudentCardUserAuth = 'PostStudentCardUserAuth',
	/**
	 * 查询申请信息
	 */
	GetApplyInfo = 'GetApplyInfo',
	/**
	 * 创建订单
	 */
	PostOrder = 'PostOrder',
	/**
	 * 通过/驳回申请信息
	 */
	PutApplyResult = 'PutApplyResult',
	/**
	 * 获取魔方软件信息
	 */
	GetAppSoftInfo = 'GetAppSoftInfo',
};

export interface IApiSourceParams {
	GetChildrenListByUserUid: Interface.IGetChildrenListByUserUidParams;
	GetDevicesByUserUid: Interface.IGetDevicesByUserUidParams;
	GetParentStudentList: Interface.IGetParentStudentListParams;
	GetUserInfo: Interface.IGetUserInfoParams;
	GetUserDetailInfo: Interface.IGetUserDetailInfoParams;
	GetYunbanUnitInfo: Interface.IGetYunbanUnitInfoParams;
	DeleteMobileRegionStayV1: Interface.IDeleteMobileRegionStayV1Params;
	GetMobileRegionStayV1: Interface.IGetMobileRegionStayV1Params;
	PostMobileRegionStayV1: Interface.IPostMobileRegionStayV1Params;
	PutMobileRegionStayV1: Interface.IPutMobileRegionStayV1Params;
	DeleteNotification: Interface.IDeleteNotificationParams;
	GetNotificationGroup: Interface.IGetNotificationGroupParams;
	GetNotificationGroupStatistics: Interface.IGetNotificationGroupStatisticsParams;
	PostSetNotificatioNGroupHasRead: Interface.IPostSetNotificatioNGroupHasReadParams;
	RequestActionByContentCallback: Interface.IRequestActionByContentCallbackParams;
	GetNotificationList: Interface.IGetNotificationListParams;
	GetNotificationNotReadMessageNums: Interface.IGetNotificationNotReadMessageNumsParams;
	GetNotificationRecordRemindItems: Interface.IGetNotificationRecordRemindItemsParams;
	PostCheckPermission: Interface.IPostCheckPermissionParams;
	PostNotificationMarkRead: Interface.IPostNotificationMarkReadParams;
	PostRequestAction: Interface.IPostRequestActionParams;
	PostLoginAccountCancel: Interface.IPostLoginAccountCancelParams;
	PostLoginAccountCancelCheck: Interface.IPostLoginAccountCancelCheckParams;
	PostLoginAccountMiniCancelCheck: Interface.IPostLoginAccountMiniCancelCheckParams;
	PostLoginInfo: Interface.IPostLoginInfoParams;
	DeleteDeviceAllMessages: Interface.IDeleteDeviceAllMessagesParams;
	DeleteDeviceMessage: Interface.IDeleteDeviceMessageParams;
	DeleteGuardArea: Interface.IDeleteGuardAreaParams;
	GetAdminDevices: Interface.IGetAdminDevicesParams;
	GetCardInfoBySncode: Interface.IGetCardInfoBySncodeParams;
	GetClassDisableSchoolConfig: Interface.IGetClassDisableSchoolConfigParams;
	GetClassDisableSelfConfig: Interface.IGetClassDisableSelfConfigParams;
	GetDeviceBindInfo: Interface.IGetDeviceBindInfoParams;
	GetDeviceDetailInfo: Interface.IGetDeviceDetailInfoParams;
	GetDeviceLocationPattern: Interface.IGetDeviceLocationPatternParams;
	GetDevicePhoneForUser: Interface.IGetDevicePhoneForUserParams;
	GetDevicePowerPlanConfig: Interface.IGetDevicePowerPlanConfigParams;
	GetDeviceReceiveMessageConfig: Interface.IGetDeviceReceiveMessageConfigParams;
	GetDeviceReceiveMessages: Interface.IGetDeviceReceiveMessagesParams;
	GetDeviceSwitchInfo: Interface.IGetDeviceSwitchInfoParams;
	GetGuardAreaList: Interface.IGetGuardAreaListParams;
	GetGuardRecord: Interface.IGetGuardRecordParams;
	GetGuardSettingSwitchInfo: Interface.IGetGuardSettingSwitchInfoParams;
	GetApplicantInfo: Interface.IGetApplicantInfoParams;
	GetMyDevices: Interface.IGetMyDevicesParams;
	GetPositionV1Realtime: Interface.IGetPositionV1RealtimeParams;
	GetTrajectoryV1: Interface.IGetTrajectoryV1Params;
	GetTrajectoryV1Step: Interface.IGetTrajectoryV1StepParams;
	AddGuardArea: Interface.IAddGuardAreaParams;
	PostClassDisableSelfConfig: Interface.IPostClassDisableSelfConfigParams;
	PostDeviceBindApplication: Interface.IPostDeviceBindApplicationParams;
	PostDeviceBindChild: Interface.IPostDeviceBindChildParams;
	PostDeviceLocationFeedback: Interface.IPostDeviceLocationFeedbackParams;
	PostDeviceLocationPattern: Interface.IPostDeviceLocationPatternParams;
	PostDevicePhoneNumber: Interface.IPostDevicePhoneNumberParams;
	PostDevicePowerPlanConfig: Interface.IPostDevicePowerPlanConfigParams;
	PostDeviceReceiveMessageConfig: Interface.IPostDeviceReceiveMessageConfigParams;
	PostDeviceSwitchStatus: Interface.IPostDeviceSwitchStatusParams;
	PostDeviceUnbind: Interface.IPostDeviceUnbindParams;
	PostPositionV1Realtime: Interface.IPostPositionV1RealtimeParams;
	PutGuardSwitchStatus: Interface.IPutGuardSwitchStatusParams;
	UpdateGuardArea: Interface.IUpdateGuardAreaParams;
	GetContactConfig: Interface.IGetContactConfigParams;
	PostContactConfig: Interface.IPostContactConfigParams;
	GetFamilyConfig: Interface.IGetFamilyConfigParams;
	PostFamilyConfig: Interface.IPostFamilyConfigParams;
	GetSosConfig: Interface.IGetSosConfigParams;
	PostSosConfig: Interface.IPostSosConfigParams;
	PostSendPhoneValid: Interface.IPostSendPhoneValidParams;
	PostSendPhoneSms: Interface.IPostSendPhoneSmsParams;
	DeleteStudentCardUserAuth: Interface.IDeleteStudentCardUserAuthParams;
	GetStudentCardUserAuth: Interface.IGetStudentCardUserAuthParams;
	GetUserAuth: Interface.IGetUserAuthParams;
	PostStudentCardUserAuth: Interface.IPostStudentCardUserAuthParams;
	GetApplyInfo: Interface.IGetApplyInfoParams;
	PostOrder: Interface.IPostOrderParams;
	PutApplyResult: Interface.IPutApplyResultParams;
	GetAppSoftInfo: Interface.IGetAppSoftInfoParams;
};

export interface IApiSourceResponse {
	GetChildrenListByUserUid: Interface.IGetChildrenListByUserUidResponse;
	GetDevicesByUserUid: Interface.IGetDevicesByUserUidResponse;
	GetParentStudentList: Interface.IGetParentStudentListResponse;
	GetUserInfo: Interface.IGetUserInfoResponse;
	GetUserDetailInfo: Interface.IGetUserDetailInfoResponse;
	GetYunbanUnitInfo: Interface.IGetYunbanUnitInfoResponse;
	DeleteMobileRegionStayV1: Interface.IDeleteMobileRegionStayV1Response;
	GetMobileRegionStayV1: Interface.IGetMobileRegionStayV1Response;
	PostMobileRegionStayV1: Interface.IPostMobileRegionStayV1Response;
	PutMobileRegionStayV1: Interface.IPutMobileRegionStayV1Response;
	DeleteNotification: Interface.IDeleteNotificationResponse;
	GetNotificationGroup: Interface.IGetNotificationGroupResponse;
	GetNotificationGroupStatistics: Interface.IGetNotificationGroupStatisticsResponse;
	PostSetNotificatioNGroupHasRead: Interface.IPostSetNotificatioNGroupHasReadResponse;
	RequestActionByContentCallback: Interface.IRequestActionByContentCallbackResponse;
	GetNotificationList: Interface.IGetNotificationListResponse;
	GetNotificationNotReadMessageNums: Interface.IGetNotificationNotReadMessageNumsResponse;
	GetNotificationRecordRemindItems: Interface.IGetNotificationRecordRemindItemsResponse;
	PostCheckPermission: Interface.IPostCheckPermissionResponse;
	PostNotificationMarkRead: Interface.IPostNotificationMarkReadResponse;
	PostRequestAction: Interface.IPostRequestActionResponse;
	PostLoginAccountCancel: Interface.IPostLoginAccountCancelResponse;
	PostLoginAccountCancelCheck: Interface.IPostLoginAccountCancelCheckResponse;
	PostLoginAccountMiniCancelCheck: Interface.IPostLoginAccountMiniCancelCheckResponse;
	PostLoginInfo: Interface.IPostLoginInfoResponse;
	DeleteDeviceAllMessages: Interface.IDeleteDeviceAllMessagesResponse;
	DeleteDeviceMessage: Interface.IDeleteDeviceMessageResponse;
	DeleteGuardArea: Interface.IDeleteGuardAreaResponse;
	GetAdminDevices: Interface.IGetAdminDevicesResponse;
	GetCardInfoBySncode: Interface.IGetCardInfoBySncodeResponse;
	GetClassDisableSchoolConfig: Interface.IGetClassDisableSchoolConfigResponse;
	GetClassDisableSelfConfig: Interface.IGetClassDisableSelfConfigResponse;
	GetDeviceBindInfo: Interface.IGetDeviceBindInfoResponse;
	GetDeviceDetailInfo: Interface.IGetDeviceDetailInfoResponse;
	GetDeviceLocationPattern: Interface.IGetDeviceLocationPatternResponse;
	GetDevicePhoneForUser: Interface.IGetDevicePhoneForUserResponse;
	GetDevicePowerPlanConfig: Interface.IGetDevicePowerPlanConfigResponse;
	GetDeviceReceiveMessageConfig: Interface.IGetDeviceReceiveMessageConfigResponse;
	GetDeviceReceiveMessages: Interface.IGetDeviceReceiveMessagesResponse;
	GetDeviceSwitchInfo: Interface.IGetDeviceSwitchInfoResponse;
	GetGuardAreaList: Interface.IGetGuardAreaListResponse;
	GetGuardRecord: Interface.IGetGuardRecordResponse;
	GetGuardSettingSwitchInfo: Interface.IGetGuardSettingSwitchInfoResponse;
	GetApplicantInfo: Interface.IGetApplicantInfoResponse;
	GetMyDevices: Interface.IGetMyDevicesResponse;
	GetPositionV1Realtime: Interface.IGetPositionV1RealtimeResponse;
	GetTrajectoryV1: Interface.IGetTrajectoryV1Response;
	GetTrajectoryV1Step: Interface.IGetTrajectoryV1StepResponse;
	AddGuardArea: Interface.IAddGuardAreaResponse;
	PostClassDisableSelfConfig: Interface.IPostClassDisableSelfConfigResponse;
	PostDeviceBindApplication: Interface.IPostDeviceBindApplicationResponse;
	PostDeviceBindChild: Interface.IPostDeviceBindChildResponse;
	PostDeviceLocationFeedback: Interface.IPostDeviceLocationFeedbackResponse;
	PostDeviceLocationPattern: Interface.IPostDeviceLocationPatternResponse;
	PostDevicePhoneNumber: Interface.IPostDevicePhoneNumberResponse;
	PostDevicePowerPlanConfig: Interface.IPostDevicePowerPlanConfigResponse;
	PostDeviceReceiveMessageConfig: Interface.IPostDeviceReceiveMessageConfigResponse;
	PostDeviceSwitchStatus: Interface.IPostDeviceSwitchStatusResponse;
	PostDeviceUnbind: Interface.IPostDeviceUnbindResponse;
	PostPositionV1Realtime: Interface.IPostPositionV1RealtimeResponse;
	PutGuardSwitchStatus: Interface.IPutGuardSwitchStatusResponse;
	UpdateGuardArea: Interface.IUpdateGuardAreaResponse;
	GetContactConfig: Interface.IGetContactConfigResponse;
	PostContactConfig: Interface.IPostContactConfigResponse;
	GetFamilyConfig: Interface.IGetFamilyConfigResponse;
	PostFamilyConfig: Interface.IPostFamilyConfigResponse;
	GetSosConfig: Interface.IGetSosConfigResponse;
	PostSosConfig: Interface.IPostSosConfigResponse;
	PostSendPhoneValid: Interface.IPostSendPhoneValidResponse;
	PostSendPhoneSms: Interface.IPostSendPhoneSmsResponse;
	DeleteStudentCardUserAuth: Interface.IDeleteStudentCardUserAuthResponse;
	GetStudentCardUserAuth: Interface.IGetStudentCardUserAuthResponse;
	GetUserAuth: Interface.IGetUserAuthResponse;
	PostStudentCardUserAuth: Interface.IPostStudentCardUserAuthResponse;
	GetApplyInfo: Interface.IGetApplyInfoResponse;
	PostOrder: Interface.IPostOrderResponse;
	PutApplyResult: Interface.IPutApplyResultResponse;
	GetAppSoftInfo: Interface.IGetAppSoftInfoResponse;
};